'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { showErrorToastWithAlgoPhoneNumber } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { ErrorMessage, Field, FieldGroup, Fieldset, Label } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { Textarea } from '@algoacademy/design-system/web/forms/Textarea';
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { cn } from '@/app/_lib/utils';
import { useTRPC } from '@/app/_trpc/config';
import { type ContactSchema, ContactSchemaZ } from '../_forms/schema';
export function ContactForm() {
  const $ = _c(69);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      resolver: zodResolver(ContactSchemaZ),
      defaultValues: {
        fullName: "",
        topic: "",
        email: "",
        content: ""
      },
      mode: "onSubmit"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    register,
    handleSubmit,
    formState: t1
  } = useForm(t0);
  const {
    errors
  } = t1;
  const trpc = useTRPC();
  let t2;
  if ($[1] !== trpc.notifications.submitContactMessage) {
    t2 = trpc.notifications.submitContactMessage.mutationOptions();
    $[1] = trpc.notifications.submitContactMessage;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const submitContactMessageMutation = useMutation(t2);
  let t3;
  if ($[3] !== submitContactMessageMutation) {
    t3 = async data => {
      try {
        await submitContactMessageMutation.mutateAsync(data);
        toast.success("Wiadomo\u015B\u0107 wys\u0142ana!", {
          description: "Odpowied\u017A otrzymasz w ci\u0105gu 3 dni roboczych."
        });
      } catch {
        showErrorToastWithAlgoPhoneNumber();
      }
    };
    $[3] = submitContactMessageMutation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSubmit = t3;
  let t4;
  if ($[5] !== handleSubmit || $[6] !== onSubmit) {
    t4 = handleSubmit(onSubmit);
    $[5] = handleSubmit;
    $[6] = onSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Label>Imię i nazwisko *</Label>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== register) {
    t6 = register("fullName");
    $[9] = register;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Input {...t6} name="fullName" type="text" />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = !errors.fullName?.message && "invisible";
  let t9;
  if ($[13] !== t8) {
    t9 = cn(t8);
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = errors.fullName?.message ?? " ";
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <ErrorMessage className={t9}>{t10}</ErrorMessage>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t7) {
    t12 = <Field>{t5}{t7}{t11}</Field>;
    $[18] = t11;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Label>E-mail *</Label>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== register) {
    t14 = register("email");
    $[22] = register;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <Input {...t14} name="email" type="email" />;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = !errors.email?.message && "invisible";
  let t17;
  if ($[26] !== t16) {
    t17 = cn(t16);
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = errors.email?.message ?? " ";
  let t19;
  if ($[28] !== t17 || $[29] !== t18) {
    t19 = <ErrorMessage className={t17}>{t18}</ErrorMessage>;
    $[28] = t17;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t15 || $[32] !== t19) {
    t20 = <Field>{t13}{t15}{t19}</Field>;
    $[31] = t15;
    $[32] = t19;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Label>Temat wiadomości *</Label>;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== register) {
    t22 = register("topic");
    $[35] = register;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  let t23;
  if ($[37] !== t22) {
    t23 = <Input {...t22} name="topic" type="text" />;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  const t24 = !errors.topic?.message && "invisible";
  let t25;
  if ($[39] !== t24) {
    t25 = cn(t24);
    $[39] = t24;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  const t26 = errors.topic?.message ?? " ";
  let t27;
  if ($[41] !== t25 || $[42] !== t26) {
    t27 = <ErrorMessage className={t25}>{t26}</ErrorMessage>;
    $[41] = t25;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] !== t23 || $[45] !== t27) {
    t28 = <Field>{t21}{t23}{t27}</Field>;
    $[44] = t23;
    $[45] = t27;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Label>Wiadomość *</Label>;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== register) {
    t30 = register("content");
    $[48] = register;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== t30) {
    t31 = <Textarea {...t30} name="content" rows={6} />;
    $[50] = t30;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  const t32 = !errors.content?.message && "invisible";
  let t33;
  if ($[52] !== t32) {
    t33 = cn(t32);
    $[52] = t32;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  const t34 = errors.content?.message ?? " ";
  let t35;
  if ($[54] !== t33 || $[55] !== t34) {
    t35 = <ErrorMessage className={t33}>{t34}</ErrorMessage>;
    $[54] = t33;
    $[55] = t34;
    $[56] = t35;
  } else {
    t35 = $[56];
  }
  let t36;
  if ($[57] !== t31 || $[58] !== t35) {
    t36 = <Field>{t29}{t31}{t35}</Field>;
    $[57] = t31;
    $[58] = t35;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== t12 || $[61] !== t20 || $[62] !== t28 || $[63] !== t36) {
    t37 = <Fieldset><FieldGroup className="space-y-6">{t12}{t20}{t28}{t36}</FieldGroup></Fieldset>;
    $[60] = t12;
    $[61] = t20;
    $[62] = t28;
    $[63] = t36;
    $[64] = t37;
  } else {
    t37 = $[64];
  }
  let t38;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Button type="submit">Wyślij wiadomość</Button>;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] !== t37 || $[67] !== t4) {
    t39 = <div className="w-full"><form onSubmit={t4} className="space-y-4">{t37}{t38}</form></div>;
    $[66] = t37;
    $[67] = t4;
    $[68] = t39;
  } else {
    t39 = $[68];
  }
  return t39;
}